module.exports = {"542527100":"措勤镇","542527200":"磁石乡","542527201":"曲洛乡","542527202":"江让乡","542527203":"达雄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542527.json
// module id = 2775
// module chunks = 0